import { render } from "./section-recipient-detail.vue?vue&type=template&id=34cbb110&ts=true"
import script from "./section-recipient-detail.vue?vue&type=script&lang=ts"
export * from "./section-recipient-detail.vue?vue&type=script&lang=ts"

import "./section-recipient-detail.vue?vue&type=style&index=0&id=34cbb110&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__